import { render } from "./ClientsView.vue?vue&type=template&id=67154f74&scoped=true&ts=true"
import script from "./ClientsView.vue?vue&type=script&lang=ts"
export * from "./ClientsView.vue?vue&type=script&lang=ts"

import "./ClientsView.vue?vue&type=style&index=0&id=67154f74&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67154f74"]])

export default __exports__